import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import _ from "lodash";
import VueLodash from "vue-lodash";
import BootstrapVue from "bootstrap-vue";
import VeeValidate, { Validator } from "vee-validate";
import installRules from "./module/commons/validator-custom";
import datePicker from "vue-bootstrap-datetimepicker";
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";
import Notifications from "vue-notification";
import uuidv4 from "uuid/v4";
import VueCookies from "vue-cookies";
import velocity from "velocity-animate";
import moment from "moment-timezone";
import VueGtag from "vue-gtag";
import store from "./store/index";
import "@/filters/filters";
import VueScrollTo from "vue-scrollto";
import initDraggableModal from "./utils/init-draggable-modal";
import VueTabEvent from "./utils/vue-tab-event";
import preventInputNumberScrolling from "./utils/prevent-input-number-scrolling";
import FloatingVue from "floating-vue";
import Confirmation from "./utils/confirmation";

// -- Global mixins
import "./module/commons/helper.js";
import numberHelper from "./module/commons/number-helper";

Vue.mixin(numberHelper);

import "./scss/apps.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "famfamfam-silk/dist/sprite/famfamfam-silk.css";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "floating-vue/dist/style.css";

// -- Google Analytics
Vue.use(
    VueGtag,
    {
        config: { id: "G-SB7V9M3V9Y" }
    },
    router
);

Vue.use(BootstrapVue);
Vue.use(VueScrollTo);
Vue.prototype.moment = moment;
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(datePicker);
Vue.use(VueLodash);
Vue.use(VueCookies);
Vue.use(Notifications, {
    velocity
});
Vue.use(Confirmation);
// Validators
Vue.use(VeeValidate);
installRules(Validator);

// -- Socket io
var socket = io.connect(process.env.SOCKET_URL, {
    secure: true,
    query: {
        source: "apps"
    }
});
Vue.use(VueSocketIOExt, socket);

Vue.use(VueTabEvent);
Vue.use(FloatingVue);

// -- Vue init mount
const vue = new Vue({
    data: {
        setting: {},
        currentActor: {},
        timesheet: {},
        permissions: {},
        instance: null,
        extensions: [],
        cc_extension: {}
    },
    router,
    store,
    created() {
        if (!localStorage.instance) {
            this.instance = uuidv4();
            localStorage.instance = this.instance;
        } else {
            this.instance = localStorage.instance;
        }

        // NOTE: Load global JS
        initDraggableModal(this.$root);
        preventInputNumberScrolling();

        // check cookies is exist
        // if (!this.$cookies.isKey("active_business_id")) {
        //     this._message("Session error", "danger");
        //     setTimeout(function () {
        //         if (window.location.port != "8080") {
        //             window.location =
        //                 process.env.APPS + "index.php/welcome/logout?f=3";
        //         }
        //     }, 1000);
        // }
    },
    render: h => h(App)
});
vue.$mount("#app");

window.appvue = vue;